import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-desktop-install-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './desktop-install-dialog.component.html',
  styleUrls: ['./desktop-install-dialog.component.scss']
})
export class DesktopInstallDialogComponent {
  title: string;
  message: string;
  downloadUrl: string;
  version: string;
  private onLaunch: (() => void) | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    const FALLBACK_DOWNLOAD_URL = 'https://ibmaspera.com/help/downloads/desktop';
    const mode = data != null && data.mode != null ? data.mode : 'install';
    const info = data != null ? data.info : null;
    const installer = info != null && info.entries != null ? info.entries[0] : null;
    this.onLaunch = data != null && data.onLaunch != null ? data.onLaunch : null;

    if (mode === 'disconnected') {
      this.title = 'Aspera for Desktop Disconnected';
      this.message = 'IBM Aspera for Desktop lost connection. Relaunch the app to continue transferring files.';
    } else {
      this.title = 'Aspera for Desktop Required';
      this.message = 'To enable Aspera uploads and downloads, please install or open IBM Aspera for Desktop.';
    }
    if (mode === 'install') {
      this.downloadUrl = (installer != null && installer.url != null) ? installer.url : FALLBACK_DOWNLOAD_URL;
      if (installer != null) { this.version = installer.version; }
    }
  }

  launch() {
    if (this.onLaunch != null) { this.onLaunch(); }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/desktop-install-dialog.component.ts